import React, { useEffect, useState } from "react";

import { motion, AnimatePresence } from "framer-motion";
import { getWalletTxns } from "../Profile/UserEndpoints";
import { Table } from "antd";
import { ExtractDate, ExtractTime, getLocalStorageItem } from "../../Utils";
import { IoCaretBack } from "react-icons/io5";
import { useCommmonStore } from "../../Store/CommonReducer";
import { useNavigate } from "react-router-dom";
import { Images } from "../../Assets/Index";

const Transactions = () => {
  const [transactions, setTransactions] = useState([]);
  const { profileDetail } = useCommmonStore();
  const navigate = useNavigate();

  const getAllTxns = () => {
    getWalletTxns()
      .then((res) => {
        if (res.status) {
          setTransactions(res.data.data);
        }
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    getAllTxns();
  }, []);
  
  const columns = [
    {
      title: "Type",
      dataIndex: "amountType",
      key: "amountType",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          {data === "cr" ? "Credit" : "Debit"}
        </p>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          ₹{data}
        </p>
      ),
    },
    {
      title: "Balance Before",
      dataIndex: "balance_before",
      key: "balance_before",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          ₹{data}
        </p>
      ),
    },
    {
      title: "Balance After",
      dataIndex: "balance_after",
      key: "balance_after",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          ₹{data}
        </p>
      ),
    },
    {
      title: "Transaction Type",
      dataIndex: "transaction_type",
      key: "transaction_type",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          {data}
        </p>
      ),
    },
    {
      title: "Time",
      dataIndex: "createdAt",
      key: "createdAt",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          {ExtractDate(data)}.{ExtractTime(data)}
        </p>
      ),
    },
  ];
  return (
    <>
      <div className="flex justify-center  items-center bg-black rounded-lg">
        <div className="w-full ">
          {/* <div className="px-4 w-full rounded-lg">
        <AnimatePresence>
          {transactions?.map((i, index) => {
            return (
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.3 }}
                key={index}
                className="bg-white font-inter p-2 mb-4 w-full"
              >
                <div className="bg-[#F2F2F1] text-gray-600 font-semibold p-2 rounded-md flex justify-between items-center text-xs mt-2">
                  <p>Type</p>
                  <p className="capitalize">
                    {i?.transaction_type?.replace("_", " ")}
                  </p>
                </div>
                <div className="bg-[#F2F2F1] text-gray-600 font-semibold p-2 rounded-md flex justify-between items-center text-xs mt-2">
                  <p>Time</p>
                  <p>{new Date(i?.createdAt)?.toLocaleString()}</p>
                </div>
                <div className="bg-[#F2F2F1] text-gray-600 font-semibold p-2 rounded-md flex justify-between items-center text-xs mt-2">
                  <p>Amount</p>
                  <p>₹ {i?.amount}</p>
                </div>
                <div className="bg-[#F2F2F1] text-gray-600 font-semibold p-2 rounded-md flex justify-between items-center text-xs mt-2">
                  <p>Balance Before</p>
                  <p>₹ {i?.balance_before}</p>
                </div>{" "}
                <div className="bg-[#F2F2F1] text-gray-600 font-semibold p-2 rounded-md flex justify-between items-center text-xs mt-2">
                  <p>Balance After</p>
                  <p>₹ {i?.balance_after}</p>
                </div>
              </motion.div>
            );
          })}
        </AnimatePresence>
      </div> */}
          <div className="flex justify-between bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f] px-8  py-2 gap-x-3 items-center ">
            <div className="text-white font-semibold flex  items-center gap-4 ">
              <IoCaretBack
                className="bg-[#ba7d13] h-7 w-7 rounded-lg cursor-pointer text-white"
                onClick={() => navigate("/wallet")}
              />
              <p className="text-xl font-normal custome">
                {getLocalStorageItem("userDetails")?.name}Transaction History
              </p>
            </div>
            <div className="flex justify-between items-center">
              <img src={Images.Money} className="w-8 m-auto my-2" alt="money" />
              <p className="text-white text-sm  custome">
                ₹ {profileDetail?.user?.wallet_balance ?? 0}
              </p>
            </div>
          </div>
          <div className="px-4 w-full rounded-lg h-screen bg-black">
            <AnimatePresence>
              <Table
                size="small"
                rowHoverable={false}
                columns={columns}
                // loading={isLoading}
                dataSource={transactions}
                className="w-screen sm:w-screen"
                // scroll={{
                //   y: 240,
                // }}
                pagination={false}
              />
            </AnimatePresence>
          </div>
        </div>
      </div>
    </>
  );
};

export default Transactions;
